import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Typography from 'material-ui/Typography';
import Toolbar from 'material-ui/Toolbar';
import Chip from 'material-ui/Chip';
import DialogModal from '../../common/DialogModal';
import Button from '../../Parts/Button';
import FaceExcellent from '../../Icons/FaceExcellent';
import FaceGood from '../../Icons/FaceGood';
import FaceSilence from '../../Icons/FaceSilence';
import Rating from '../../common/Rating';
import { formatName } from '../../../utils/utils';
import { AddressBookTab, addressItemFormProps, WarningAddressType } from '../../../constants/ComponentTypes';

const styles = () => ({
  paper: {
    maxHeight: 'unset',
    background: "#F4F6F9",
    width: '80%',
    minWidth: '80%',
    marginTop: '50px',
  },

  contentContainer: {
    margin: '0px',
    padding: '0px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
  },

  gutters: {
    background: "#FFFFFF",
    fontSize: "15px",
    fontWeight: 700,
    boxShadow: '0px 1px 0px #00000029',
    width: '100%',
    padding: '28px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxSizing: 'border-box',
  },

  content: {
    width: '100%',
    display: 'flex',
    background: '#FFF',
  },

  address: {
    width: '50%',
    padding: '30px',
    boxSizing: 'border-box',
  },

  addressInner: {
    width: '100%',
    background: '#FFF',
    padding: '30px',
    boxSizing: 'border-box',
    marginTop: '30px',
    textAlign: 'left',
  },

  addressHeader: {
    display: 'flex',
    alignItems: 'center',
  },

  addressTitle: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    marginLeft: '25px',
  },

  entry: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    width: '100%',
    marginTop: '25px',
  },

  label: {
    color: '#71737B',
    fontSize: '11px',
  },

  value: {
    fontSize: '15px',
    color: '#181819',
    boxShadow: '0px 1px 0px #00000029',
    width: '100%',
    padding: '15px 10px',
    boxSizing: 'border-box',
    textAlign: 'left',
    minHeight: '54px',
  },

  chipRoot: {
    marginRight: '10px',
    marginBottom: '5px',
    float: 'left',
    backgroundColor: 'rgba(26,101,255,.05)',
    border: '#1A65FF solid 1px',
    color: '#1A65FF',
    height: 'unset',
  },

  chipLabel: {
    padding: '5px 10px',
    fontSize: '11px',
  }
});

class DetailDialog extends React.Component {
  state = {
    title: "住所",
    isReferExecutivePerson: false,
  }

  componentWillMount() {
    const { item } = this.props;
    const isDuplicateExe = (item.type === WarningAddressType['DUPLICATE_EXECUTIVE_PERSON'].value)

    let title;

    if (isDuplicateExe) {
      title = "キーマンデータベースとの内容";
    } else {
      title = "住所";

      if (item && item.duplicate_address) {
        if (item.company && item.company === item.duplicate_address.company) {
          title = title + "・会社名";
        }

        if (item.name && item.name === item.duplicate_address.name) {
          title = title + "・名前";
        }
      }
    }

    this.setState({
      title: title,
      isDuplicateExe: isDuplicateExe
    })
  }

  componentWillReceiveProps(nextProps) {
    if ((this.props.isDeleting && nextProps.isDeleting === false) ||
      (this.props.isOverwritingWarningAddress && nextProps.isOverwritingWarningAddress === false) ||
      (this.props.isPostWarningAddressWithExecutivePerson && nextProps.isPostWarningAddressWithExecutivePerson === false)) {
      this.props.onClose();
    }
  }

  overwriteAddress = () => () => {
    this.props.postWarningAddressOverwrite(this.props.item.id);
  }

  postWarningAddressWithExecutivePerson = (item, isReferExecutivePerson) => () => {
    this.setState({
      isReferExecutivePerson: isReferExecutivePerson
    });
    this.props.postWarningAddressWithExecutivePerson(item.id, isReferExecutivePerson);
  }

  renderIcon = (status) => {
    switch (status) {
      case AddressBookTab.SILENT:
        return <FaceSilence width={60} height={60} />
      case AddressBookTab.REACTED:
        return <FaceGood width={60} height={60} />
      case AddressBookTab.CONVERTED:
        return <FaceExcellent width={60} height={60} />
      default:
        return <FaceSilence width={60} height={60} />
    }
  };

  renderAddress = (title, backgroundColor, item) => {
    const { classes } = this.props;

    return (
      <div className={classes.address} style={{ background: backgroundColor }}>
        <Typography variant="subheading">{title}</Typography>
        <div className={classes.addressInner}>
          <div className={classes.addressHeader}>
            {this.renderIcon(item.status)}
            <div className={classes.addressTitle}>
              <Typography variant="title" style={{ fontWeight: 'bold', minHeight: '21px' }}>{formatName(item)}</Typography>
              <Typography variant="body1" style={{ marginTop: '3px', minHeight: '16px' }}>{item.address}</Typography>
              <Rating rating={item.rating ? item.rating : 0} />
            </div>
          </div>

          <div className={classes.addressContent}>
            {addressItemFormProps.filter(prop => prop.key !== 'corporate_number').map(prop => (
              <div key={prop.key} className={classes.entry}>
                <label className={classes.label}>{prop.value}</label>
                {(() => {
                  if (prop.key === 'tags') {
                    if (item && item[prop.key] && item[prop.key].length > 0) {
                      return (
                        <div className={classes.value}>
                          {item[prop.key].map((tag, i) => (
                            <Chip
                              key={i}
                              label={tag}
                              color="primary"
                              classes={{
                                root: classes.chipRoot,
                                label: classes.chipLabel,
                              }}
                            />
                          ))}
                        </div>
                      )
                    } else {
                      return <div className={classes.value} style={{ minHeight: '60px' }}></div>
                    }
                  } else {
                    return <div className={classes.value}>{item[prop.key]}</div>
                  }
                })()}
              </div>
            ))}
          </div>
        </div>
      </div>
    )
  }

  render() {
    const { classes, onClose, isOpen, item, isDeleting, isOverwritingWarningAddress, isPostWarningAddressWithExecutivePerson } = this.props;

    return (
      <DialogModal
        open={isOpen}
        onClose={onClose}
        maxWidth={false}
        classes={{
          contentContainer: classes.contentContainer,
          paper: classes.paper,
        }}
      >
        <Toolbar classes={{ gutters: classes.gutters }}>
          <Typography variant="subheading" style={{ fontWeight: 'bold' }}>
            {this.state.title}が重複しているアドレスを登録しようとしています
          </Typography>

          {!this.state.isDuplicateExe && (
            <Button
              text="差分を上書き"
              handleClickButton={this.overwriteAddress(item)}
              type="ghost"
              size="small"
              loading={isOverwritingWarningAddress}
              style={{ marginLeft: '30px' }}
            />
          )}

          {this.state.isDuplicateExe && (
            <Button
              text="キーマンデータベースを参照して保存"
              handleClickButton={this.postWarningAddressWithExecutivePerson(item, true)}
              type="ghost"
              size="small"
              loading={isPostWarningAddressWithExecutivePerson && this.state.isReferExecutivePerson}
              style={{ marginLeft: '30px' }}
            />
          )}

          {this.state.isDuplicateExe && (
            <Button
              text="そのまま保存"
              handleClickButton={this.postWarningAddressWithExecutivePerson(item, false)}
              type="ghost"
              size="small"
              loading={isPostWarningAddressWithExecutivePerson && !this.state.isReferExecutivePerson}
              style={{ marginLeft: '15px' }}
            />
          )}


          <Button
            text="削除"
            handleClickButton={() => { this.props.remove({ warning_address_ids: [item.id] }) }}
            type="ghost"
            size="small"
            loading={isDeleting}
            style={{ marginLeft: '15px' }}
          />
        </Toolbar>
        <div className={classes.content}>
          {this.renderAddress(
            this.state.isDuplicateExe ? 'キーマンデータベースのアドレス' : 'すでに登録されているアドレス',
            'rgba(26,101,255,.05)',
            this.state.isDuplicateExe ? item.duplicate_executive_person : item.duplicate_address
          )}

          {this.renderAddress('登録しようとしているアドレス', 'rgba(0,0,0,.05)', item)}
        </div>
      </DialogModal>
    );
  }
}

DetailDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  item: PropTypes.object.isRequired,
  remove: PropTypes.func.isRequired,
  isDeleting: PropTypes.bool.isRequired,
  postWarningAddressOverwrite: PropTypes.func.isRequired,
  isOverwritingWarningAddress: PropTypes.bool.isRequired,
  isPostWarningAddressWithExecutivePerson: PropTypes.bool.isRequired,
  postWarningAddressWithExecutivePerson: PropTypes.func.isRequired,
};

export default withStyles(styles)(DetailDialog);



// WEBPACK FOOTER //
// ./src/components/AddressBook/dialogs/DetailDialog.jsx